<!--
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-06-21 08:35:00
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2024-08-02 13:52:32
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\components\breadcrumb\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="pan-main-breadcrumb-content">
        <el-breadcrumb style="display: inline-block;">
            <el-breadcrumb-item>
                <a class="breadcrumb-item-a" @click="goBack" href="#">返回</a>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider direction="vertical" style="vertical-align: top !important;" />
        <el-breadcrumb separator-class="el-icon-arrow-right" style="display: inline-block;">
            <el-breadcrumb-item v-for="(item, index) in breadCrumbs" :key="item.flowNo">
                <a class="breadcrumb-item-a" @click="goToThis(item.flowNo)" href="#">{{ item.name }}</a>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'BreadCrumb',
    components: {},
    props: {
    },
    data() {
        return {
        }
    },
    methods: {
        ...mapMutations({
            resetParentId: 'file/setFileParentId',
            clearBreadCrumb: 'breadcrumb/clear',
            resetBreadCrumb: 'breadcrumb/reset',
            setSearchFlag: 'file/setSearchFlag'
        }),
        ...mapActions({
            reloadFileList: 'file/loadFileList'
        }),
        goBack() {
            let _this = this
            _this.setSearchFlag(false)
            if (_this.breadCrumbs.length > 1) {
                let resolveBreadCrumbs = [..._this.breadCrumbs]
                resolveBreadCrumbs.pop()
                let newId = resolveBreadCrumbs[resolveBreadCrumbs.length - 1].flowNo
                _this.goToThis(newId)
            } else {
                _this.goToThis(null)
            }
        },
        goToThis(flowNo) {
            if (flowNo) {
                let newBreadCrumbs = new Array()
                this.breadCrumbs.some(item => {
                    newBreadCrumbs.push(item)
                    if (item.flowNo == flowNo) {
                        return true
                    }
                })
                this.resetBreadCrumb(newBreadCrumbs)
                this.resetParentId(flowNo)
            } else {
                this.clearBreadCrumb()
                this.resetParentId(null)
            }

            this.setSearchFlag(false)
            this.reloadFileList()
        }
    },
    computed: {
        ...mapGetters(['breadCrumbs'])
    },
    mounted() {
    },
    watch: {}
}
</script>

<style>
.pan-main-breadcrumb-content {
    width: 100%;
    padding: 10px 0 0 25px;
}

.breadcrumb-item-a {
    cursor: pointer !important;
    color: #409EFF !important;
}
</style>